import { CampaignGoalEnum } from '../../../constants/Enums';
import { SearchBurstCampaignsByNameStarts, SearchCampaignsByNameStarts } from './CampaignBriefDataService';
import { DefaultInputStatus, ErrorInputStatus, SuccessInputStatus } from './CampaignBriefUtils';

export const validateName = async (campaignId, searchValue, minLengthToStartSearch, validationOnly) => {
    const result = {
        status: DefaultInputStatus,
        searchResults: []
    };

    if ((!searchValue || searchValue.length < minLengthToStartSearch) && !validationOnly) {
        return result;
    }

    if (validationOnly && !searchValue) {
        result.status = ErrorInputStatus(window.translate('Campaign name is required'));
        return result;
    }

    const results = await SearchCampaignsByNameStarts(searchValue);

    // Remove the current name because we don't want the name matching with itself
    const searchData = results.filter((p) => p.id !== campaignId).map((p) => p.name.trim());

    // We also need to set the status to green if no exact matches found
    if (searchData.findIndex((data) => data.toLowerCase() === searchValue.toLowerCase().trim()) === -1) {
        if (!validationOnly) {
            result.status = SuccessInputStatus();
        }
    } else {
        result.status = ErrorInputStatus('Campaign name already exists');
    }

    if (!validationOnly) {
        result.searchResults = searchData;
    }

    return result;
};

export const validateBurstName = async (parentCampaignId, campaignBurstId, searchValue, minLengthToStartSearch, validationOnly) => {
    const result = {
        status: DefaultInputStatus,
        searchResults: []
    };

    if ((!searchValue || searchValue.length < minLengthToStartSearch) && !validationOnly) {
        return result;
    }

    if (validationOnly && !searchValue) {
        result.status = ErrorInputStatus(window.translate('Campaign burst name is required'));
        return result;
    }

    const results = await SearchBurstCampaignsByNameStarts(parentCampaignId, searchValue);

    // Remove the current name because we don't want the name matching with itself
    const searchData = results.filter((p) => p.id !== campaignBurstId).map((p) => p.name.trim());

    // We also need to set the status to green if no exact matches found
    if (searchData.findIndex((data) => data.toLowerCase() === searchValue.toLowerCase().trim()) === -1) {
        if (!validationOnly) {
            result.status = SuccessInputStatus();
        }
    } else {
        result.status = ErrorInputStatus('Campaign burst name already exists');
    }

    if (!validationOnly) {
        result.searchResults = searchData;
    }

    return result;
};

export const validateBudget = (budget, opportunityBudget, goals = []) => {
    if (budget) {
        const budgetIdx = goals.findIndex((s) => s.goal === 'budget');
        if (goals && budgetIdx !== -1) goals[budgetIdx].value = budget;

        if (opportunityBudget) {
            if (budget <= opportunityBudget) {
                return true;
            }
        }
        return true;
    } else {
        return false;
    }
};

// This could be one ValidateDates function taking dateOne and datetwo as args but you'll also have to handle the check, do we want that
export const validateStartDate = (startDate, endDate) => {
    const eDate = new Date(endDate);
    const sDate = new Date(startDate);
    if (sDate && sDate <= eDate) {
        return true;
    } else {
        return false;
    }
};

export const validateCampaignGoal = (campaign) => {
    const selectGoal = campaign?.campaignGoal?.find((g) => g.selected === true);

    if (selectGoal?.goal === CampaignGoalEnum.WEEKLYBUDGET) {
        if (selectGoal.value === '-') {
            return true;
        }
    }

    if (selectGoal?.value > 0) {
        return true;
    } else {
        return false;
    }
};

export const validateEndDate = (startDate, endDate) => {
    const eDate = new Date(endDate);
    const sDate = new Date(startDate);
    if (eDate && sDate <= eDate) {
        return true;
    } else {
        return false;
    }
};

export const validateAdvertiser = (advertiserId, advertiserName) => {
    if (advertiserId && advertiserName) {
        return true;
    } else {
        return false;
    }
};

export const validateAgency = (agencyId, agencyName) => {
    if (agencyId && agencyName) {
        return true;
    } else {
        return false;
    }
};

export const validateDeal = (dealVersionId, isAirtime) => {
    if ((dealVersionId && dealVersionId !== window.emptyGuid) || !isAirtime) {
        return true;
    } else {
        return false;
    }
};

export const validateCategory = (categoryId, categoryName, isbusinessTypeOffair) => {
    if ((categoryId && categoryName) || isbusinessTypeOffair) {
        return true;
    } else {
        return false;
    }
};

export const validatePoNumbers = (poNumbersJson) => {
    // I'm assuming here that you must have all the poNumbers in multiple filled out before you can book.
    return (poNumbersJson.usingSingle && poNumbersJson.single) ||
        (!poNumbersJson.usingSingle && poNumbersJson.multiple.length === poNumbersJson.multiple.filter((po) => po.poNumber).length) ||
        false;
};

export const validateBillingTerms = (billingTermId) => {
    return billingTermId && billingTermId !== '-1';
}

export const validateTaxRate = (vatId) => {
    return vatId && vatId !== '-1';
}
